
import { CountUp } from 'countup.js';
import { onMounted, ref } from 'vue';
import log from '@/global/log';
import {
	Controller,
	Autoplay,
} from 'swiper/modules';
import {
	Swiper,
	SwiperSlide,
	useSwiper,
} from 'swiper/vue';
import 'swiper/css';
export default {
	components: {
		Swiper,
		SwiperSlide,
	},
	setup() {
		let activeTabIndex = ref(-1);
		// 타이머 아이디를 저장할 변수
		let intervalId;
		let cardSwiper = ref(null);
		let tabSwiper = ref(null);
		let tabIndex = ref(0);
		let configSwiper = ref(null);
		let configSwiper2 = ref(null);
		let hoverIndex = ref(0);
		let isMobile = ref();
		let activeProjectIndex = ref(-1);
		let count1 = ref();
		let count2 = ref();

		const cardTimer = () => {
			if (activeTabIndex.value < 4) {
				activeTabIndex.value++;
				log(
					'activeTabIndex : ' +
						activeTabIndex.value
				);
			} else {
				activeTabIndex.value = 0;
			}
		};
		const imgTimer = () => {
			if (activeProjectIndex.value < 1) {
				activeProjectIndex.value++;
				log(
					'activeProjectIndex : ' +
						activeProjectIndex.value
				);
			} else {
				activeProjectIndex.value = 0;
			}
		};

		// Intersection Observer를 생성하고 콜백 함수를 정의합니다.
		const tabObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						// div가 화면에 보이면 실행할 동작을 여기에 추가합니다.
						log(
							'activeTabIndex : ' +
								activeTabIndex.value
						);
						activeTabIndex.value++;
						intervalId = setInterval(() => {
							cardTimer();
						}, 6000);
					} else {
						// div가 화면에서 사라지면 실행할 동작을 여기에 추가합니다.
						clearInterval(intervalId);
						activeTabIndex.value = -1;
					}
				});
			}
		);
		const imgObserver = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						// div가 화면에 보이면 실행할 동작을 여기에 추가합니다.
						log(
							'activeProjectIndex : ' +
								activeProjectIndex.value
						);
						activeProjectIndex.value++;
						intervalId = setInterval(() => {
							imgTimer();
						}, 6000);
					}
					// else {
					// 	// div가 화면에서 사라지면 실행할 동작을 여기에 추가합니다.
					// 	clearInterval(intervalId);
					// 	activeProjectIndex.value = -1;
					// }
				});
			}
		);
		const cntObserver1 = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						log('count1.start');
						// div가 화면에 보이면 실행할 동작을 여기에 추가합니다.
						count1.value.start();
					}
				});
			}
		);
		const cntObserver2 = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						// div가 화면에 보이면 실행할 동작을 여기에 추가합니다.
						log('count2.start');
						count2.value.start();
					}
				});
			}
		);

		// 타이머를 중지하고 다시 시작하는 함수 예제
		function stopAndStartTimer() {
			log('stopAndStartTimer');
			// 타이머를 중지합니다.
			clearInterval(intervalId);
			activeTabIndex.value = 0;
			log(
				'activeTabIndex : ' + activeTabIndex.value
			);

			// 다시 시작합니다.
			intervalId = setInterval(cardTimer, 6000);
		}

		const onCardSwiper = (swiper) => {
			log('cardSwiper', swiper);
			cardSwiper.value = swiper;
		};
		const onTabSwiper = (swiper) => {
			log('onTabSwiper', swiper);
			tabSwiper.value = swiper;
		};
		const onConfigSwiper = (swiper) => {
			log('onConfigSwiper', swiper);
			configSwiper.value = swiper;
		};
		const onConfigSwiper2 = (swiper) => {
			log('onConfigSwiper2', swiper);
			configSwiper2.value = swiper;
		};

		const openEmail = () => {
			// 사용자의 이메일 주소와 이메일 제목, 본문 등을 설정합니다.
			const emailAddress =
				'thejoin@thejoin.co.kr';
			const subject = '제목을 입력하세요';
			const body = '본문을 입력하세요';

			// "mailto" 링크를 생성합니다.
			const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(
				subject
			)}&body=${encodeURIComponent(body)}`;

			// "mailto" 링크를 클릭하여 사용자의 이메일 클라이언트를 엽니다.
			window.location.href = mailtoLink;
		};

		const openCall = () => {
			window.location.href = 'tel:02-6949-0335'; // 원하는 전화번호로 변경
		};

		onMounted(() => {
			const cardEl = document.getElementById(
				'card'
			) as HTMLElement;
			if (cardEl) {
				tabObserver.observe(cardEl!);
			}
			const imageEl = document.getElementById(
				'image'
			) as HTMLImageElement;

			if (imageEl) {
				imgObserver.observe(imageEl!);
			}

			count1.value = new CountUp(
				'count1',
				230000,
				{
					enableScrollSpy: true,
					startVal: 200000,
				}
			);
			count2.value = new CountUp('count2', 28, {
				enableScrollSpy: true,
			});

			// count1.value.start();
			const cntEl1 = document.getElementById(
				'count1'
			) as HTMLElement;
			const cntEl2 = document.getElementById(
				'count2'
			) as HTMLElement;

			if (cntEl1 && cntEl2) {
				cntObserver1.observe(cntEl1);
				cntObserver2.observe(cntEl2);
			}

			const screenWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			if (screenWidth < 768) {
				isMobile.value = true;
			} else {
				isMobile.value = false;
			}
			window.addEventListener('resize', () => {
				const screenWidth =
					window.innerWidth ||
					document.documentElement.clientWidth ||
					document.body.clientWidth;
				if (screenWidth < 768) {
					isMobile.value = true;
				} else {
					isMobile.value = false;
				}
			});
		});

		return {
			activeTabIndex,
			stopAndStartTimer,
			cardTabArr: [
				{
					title: '운영환경',
					img: require('@/assets/images/health/category1.png'),
				},
				{
					title: '모바일 APP',
					img: require('@/assets/images/health/category2.png'),
				},
				{
					title: '관리자 WEB',
					img: require('@/assets/images/health/category3.png'),
				},
				{
					title: '데이터',
					img: require('@/assets/images/health/category4.png'),
				},
				{
					title: '운영지원',
					img: require('@/assets/images/health/category5.png'),
				},
			],
			mobileCardArr: [
				require('@/assets/images/health/cate_1.png'),
				require('@/assets/images/health/cate_2.png'),
				require('@/assets/images/health/cate_3.png'),
				require('@/assets/images/health/cate_4.png'),
				require('@/assets/images/health/cate_5.png'),
			],
			Controller,
			Autoplay,
			tabIndex,
			onCardSwiper,
			onTabSwiper,
			tabSwiper,
			cardSwiper,
			tabOption: {
				// 네비게이션
				navigation: false,
				// 페이지네이션
				pagination: false,
				slidesPerView: 3,
				breakpoints: {
					0: {
						slidesPerView: 3,
					},
					500: {
						slidesPerView: 5,
					},
				},
			},
			cardOption: {
				// 네비게이션
				navigation: false,
				// 페이지네이션
				pagination: false,
				slidesPerView: 1.2,
				spaceBetween: 10,
				autoplay: {
					delay: 6000, // 시간 설정
					disableOnInteraction: true, // false-스와이프 후 자동 재생
					loop: true,
				},
				breakpoints: {
					0: {
						slidesPerView: 1.1,
					},
					500: {
						slidesPerView: 2,
					},
				},
			},
			hoverIndex,
			hoverInfo: [
				{
					btnTxt: '헬스케어 플랫폼 구성도',
					color: '#3170CF',
					subtitle:
						'헬스케어 플랫폼은 개인정보 분석을 기반으로 단위 시스템 간 유기적인 연동체계가 구현되어 있습니다.<br> 기본적으로 제공되는 기능 이외에 당신의 프로젝트 요구사항을 반영하는 커스텀 서비스도 이용할 수 있습니다.',
				},
				{
					btnTxt: '고객 서비스 제공',
					color: '#4D54D9',
					subtitle:
						'사용자에게 건강한 생활습관을 유도하고 자가 건강관리 역량을 강화할 수 있는<br>신체활동, 식이, 운동 등 토탈 헬스케어 서비스를 제공합니다.',
				},
				{
					btnTxt: '데이터 분석',
					color: '#5A95F0',
					subtitle:
						'모바일에서 수집되는 개인건강정보를 안전하게 관리하고 분석하여<br>사용자에게 맞춤형 컨텐츠를 제공하고 서비스 운영을 지원하는 관리기능을 제공합니다.',
				},
				{
					btnTxt: '서비스 API',
					color: '#5878E7',
					subtitle:
						'우리는 검증된 국내 헬스케어 관련 스타트업과 협업하고 있고 지속적으로 확대할 것입니다.<br>이를 통해 AI기반의 식이관리, 홈트레이닝 등 더욱 다양한 헬스케어 서비스를 사용자에게 제공합니다.',
				},
				{
					btnTxt: '외부 연계 API',
					color: '#5878E7',
					subtitle:
						'플랫폼에서 수집되는 정보는 서비스 공급자가 원할 경우 실시간으로 전송할 수 있습니다.<br>서비스 기간동안 수집되는 정보를 기관에서 활용할 수 있도록 지원합니다.',
				},
				{
					btnTxt: '운영 시스템 관리',
					color: '#5878E7',
					subtitle:
						'최적의 서비스 환경을 유지하기 위해 성능관리 툴, 개인정보 보안감시 시스템 등이 적용되어 있으며<br>효과적인 운영지원 업무를 제공합니다.',
				},
				{
					btnTxt: '데이터 공유',
					color: '#51C5DE',
					subtitle:
						'서비스 공급자는 서비스 상태와 사용자 정보를 모니터링하고 서비스를 관리할 수 있습니다.<br>우리는 전문 운영팀을 배치하여 안정적으로 서비스가 제공될 수 있도록 관리합니다.',
				},
				{
					btnTxt: '연계 시스템',
					color: '#FFB018',
					subtitle:
						'건강생활 실천을 통해 획득한 포인트 정보를 지역화폐, 지역서비스 등의 서비스와 연계하여<br>지속적인 서비스 참여를 유도할 수 있습니다.',
				},
			],
			configTabletImg: [
				require('@/assets/images/health/config_t1.png'),
				require('@/assets/images/health/config_t2.png'),
				require('@/assets/images/health/config_t3.png'),
				require('@/assets/images/health/config_t4.png'),
				require('@/assets/images/health/config_t5.png'),
				require('@/assets/images/health/config_t6.png'),
				require('@/assets/images/health/config_t7.png'),
				require('@/assets/images/health/config_t8.png'),
			],
			configMobileImg: [
				require('@/assets/images/health/config_m1.png'),
				require('@/assets/images/health/config_m2.png'),
				require('@/assets/images/health/config_m3.png'),
				require('@/assets/images/health/config_m4.png'),
				require('@/assets/images/health/config_m5.png'),
				require('@/assets/images/health/config_m6.png'),
				require('@/assets/images/health/config_m7.png'),
			],
			onConfigSwiper,
			configSwiper,
			onConfigSwiper2,
			configSwiper2,
			openEmail,
			openCall,
			isMobile,
			projectImg: [
				require('@/assets/images/health/project1.png'),
				require('@/assets/images/health/project2.png'),
			],
			activeProjectIndex,
		};
	},
};
